import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getPatientFulfillmentOrders = (state, patientId) =>
  allModelsSelector(state, 'PatientFulfillmentOrder', (pfo) => pfo.patientId === patientId).sort(
    (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
  );
